var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.293 2c-.95.252-4.83 1.753-5.447 2.303-.174.154-2.83 6.514-3.844 7.915-.119.19 4.57 1.956 5.443 2.3v11.361h14.11V14.518c.872-.344 5.56-2.108 5.443-2.3-1.013-1.4-3.67-7.761-3.844-7.915-.617-.55-4.497-2.05-5.447-2.303-.696 2.643-5.718 2.641-6.414 0",
    fill: "#000",
    fillRule: "evenodd"
  })));
}

export default SvgTop;